module.exports = __webpack_public_path__ + "static/img/wx05.a9986ce5.png";